export const keysServicesEnUs = {
  'services.mymdm.title': 'MyMDM',
  'services.mymdm.titlePartial': 'MDM',
  'services.mymdm.subtitle': 'Endpoint monitoring and management platform',
  'services.mymdm.monitoring': 'Remote monitoring of terminals in real time through different dashboards',
  'services.mymdm.monitoringPartial': 'Monitoring',
  'services.mymdm.settings':
    'Remote configuration and the option to enable or disable terminal configuration functions',
  'services.mymdm.settingsPartial': 'Remote Setting',
  'services.mymdm.custom': 'Remote launcher customization and application access options',
  'services.mymdm.customPartial': 'Remote launcher customization',
  'services.mymdm.install': 'Remote installation and update of applications',
  'services.mymdm.installPartial': 'Remote installation and update',
  'services.mymdm.access': 'Access to the 24x7 subscription robot',
  'services.mymdm.accessPartial1': 'Access',
  'services.mymdm.accessPartial2': '24x7',
  'services.mymdm.apps': 'Manage app and versions available to your users',
  'services.mymdm.appsPartial': 'Manage app and versions',
  'services.mymdm.support': 'Remote Support available by device and user',
  'services.mymdm.supportPartial': 'Remote Support',
  'services.mymdm.panel': 'Create customized dashboards and reports for data analysis according to your interests',
  'services.mymdm.panelPartial': 'Create custom dashboards and reports',
  'services.mymdm.cost': 'Reduce operational cost with installations, service and support incidents',
  'services.mymdm.costPartial': 'Reduce cost',
  'services.mymdm.increase':
    'Increase availability of use and ensure high terminal performance through preventive monitoring and scheduled updates',
  'services.mymdm.increasePartial': 'Increase',

  'services.mymdm.footerDescription':
    'MyMDM is a complete tool that allows the customer or partner to remotely manage their terminal base, including terminal monitoring and configuration resources and the distribution or updating of applications through MyMDM itself or through the Smart Store.',
  'services.mymdm.footerDescriptionPartial1': 'MyMDM',
  'services.mymdm.footerDescriptionPartial2': 'Smart Store',
  'services.mymdm.footerActionButton': "I'm interested",

  'services.mynps.title': 'MyNPS',
  'services.mynps.subtitle': 'Satisfaction survey in Net Promoter Score format',
  'services.mynps.footerDescription':
    'MyNPS is a complete platform that can work integrated with other Gertec PINPADs to collect information at the time of sale. Data is captured in NPS (Net Promoter Score) format and can be integrated with automation or back-office systems through the platform APIs.',
  'services.mynps.footerDescriptionPartial': 'MyNPS',
  'services.mynps.benefit.cloud': '100% Cloud solution;',
  'services.mynps.benefit.cloudPartial': '100% Cloud solution',
  'services.mynps.benefit.pinpad': 'Integration with Gertec PINPAD;',
  'services.mynps.benefit.pinpadPartial': 'Integration with Gertec PINPAD',
  'services.mynps.benefit.commercialAutomation': 'Integration with commercial automation;',
  'services.mynps.benefit.commercialAutomationPartial': 'Integration with commercial automation',
  'services.mynps.benefit.noHardware': 'Operation without additional hardware;',
  'services.mynps.benefit.noHardwarePartial': 'without additional hardware',
  'services.mynps.benefit.dashboards': 'Several dashboards and reports;',
  'services.mynps.benefit.dashboardsPartial': 'dashboards and reports',
  'services.mynps.benefit.npsFormat': 'Availability in NPS format.',
  'services.mynps.benefit.npsFormatPartial': 'NPS format',
  'services.mynps.footerActionButton': "I'm interested"
};
